// extracted by mini-css-extract-plugin
export default {"banner":"DuplicatesBanner_banner__+zszx","iconWrap":"DuplicatesBanner_iconWrap__TT6ii"};